export default "__VITE_ASSET__459a079b__"